import * as Yup from 'yup';

const fields: Record<string, Record<string, any>> = {
    metatag: [
        {
            name: 'metatag',
            label: null,
            type: 'text',
            placeholder: 'Мета-тэг',
            position: 10,
        },
    ],
    keys: [
        {
            name: 'project_id',
            label: null,
            type: 'text',
            placeholder: 'ID проекта',
            position: 10,
        },
        {
            name: 'secretKey',
            label: null,
            type: 'password',
            placeholder: 'Секретный ключ проекта',
            position: 10,
        },
        {
            name: 'public_key',
            label: null,
            type: 'text',
            placeholder: 'Публичный ключ',
            position: 10,
        },
    ],
};

export const getFields = (type: string) => fields[type];

export const validationSchema = Yup.object({
    metatag: Yup.string()
        .required('Укажите мета-тэг')
        .matches(
            /^<meta\s+name=["']verification["']\s+content=["'][a-zA-Z0-9]+["']\s*\/?>$/,
            'Введите корректный мета-тэг вида <meta name="verification" content="..."/>'
        ),
});

export const validationSchemaKeys = Yup.object({
    project_id: Yup.number().required('Укажите ID проекта'),
    secretKey: Yup.string().required('Укажите секретный ключ проекта'),
    public_key: Yup.string().required('Укажите публичный ключ проекта'),
});

const initialValuesMap: Record<string, Record<string, any>> = {
    metatag: {
        metatag: null,
    },
    keys: {
        project_id: null,
        secretKey: null,
        public_key: null,
    },
};

export const getInitialValues = (type: string) => initialValuesMap[type];
